import { MESSENGER_CSS } from "@kobecuppens/livechat-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { I18nProvider } from "./i18n";
import { Router } from "./router";
import "./styles.css";

// This host is Snory's. The same build serves other products, so the site
// palette stays on the hostname.
if (location.hostname.endsWith("snorystories.app")) document.documentElement.dataset.brand = "snory";

// Reuse the SDK's markdown styles (scoped under .lc-md) for previews and message bodies.
const md = document.createElement("style");
md.textContent = MESSENGER_CSS.split("\n").filter((l) => l.startsWith(".lc-md")).join("\n");
document.head.appendChild(md);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider>
      <ErrorBoundary>
        <Router>
          <App />
        </Router>
      </ErrorBoundary>
    </I18nProvider>
  </StrictMode>,
);
